import _get from 'lodash/get';
import { a as _objectSpread } from '../chunk-ad6ad343.js';

var Pane = (function (overrides) {
  return _objectSpread({}, _get(overrides, 'Pane', {}), {
    elevations: _objectSpread({
      100: 4,
      200: 8,
      300: 12,
      400: 24
    }, _get(overrides, 'Pane.elevations', {}))
  });
});

export default Pane;
